module.exports = __webpack_public_path__ + "img/us_product@2x.61c9bbd7.png";